import { client } from '../http';

export async function createScenario({ name, categories }) {
  const response = await client.post('/api/planner-scenarios', { name, categories });
  return response.data;
}

export async function getScenarios() {
  const response = await client.get('/api/planner-scenarios');
  return response.data;
}

export async function getScenario(scenarioId) {
  const response = await client.get(`/api/planner-scenarios/${scenarioId}`);
  return response.data;
}

export async function updateScenario(scenarioId, { name, categories }) {
  const payload = {};
  if (name !== undefined) {
    payload.name = name;
  }
  if (categories !== undefined) {
    payload.categories = categories;
  }
  const response = await client.put(`/api/planner-scenarios/${scenarioId}`, payload);
  return response.data;
}

export async function deleteScenario(scenarioId) {
  await client.delete(`/api/planner-scenarios/${scenarioId}`);
}
